module.exports = __webpack_public_path__ + "static/media/dotJoin.88c1ea51.png";